import axios from "axios";

const REACT_APP_BACKEND_URL = "https://truly-contacts.herokuapp.com/api";
// const baseURL = process.env.REACT_APP_BACKEND_URL;
const baseURL = REACT_APP_BACKEND_URL;

console.log("REACT_APP_BACKEND_URL", baseURL);

let headers = {};

if (localStorage.token) {
  headers.Authorization = `Bearer ${localStorage.token}`;
}

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers,
});

export default axiosInstance;
